<ng-container>
  <div class="col-md-12 p-0 pb-4 float-right d-flex justify-content-between">
    <h3 class="mt-2 font-text-600 titleName">User Profile</h3>
    <!-- <button class="btn back-btn p-1 font-lg-size">
    <i class="fas fa-level-down-alt fa-rotate-90" aria-hidden="true"></i>
  </button> -->
</div><br><br>

<h4 class="mt-5 font-text-600">User Profile Information</h4>
@if (profileDetailsForm) {
  <form [formGroup]="profileDetailsForm">
    <div></div>
    <div class="col-md-12 float-left customersearch-forms login-forms customer-home-forms mb-1">
      <!-- <span class="pl-0">Personal Information</span> -->
      <div>
        <div class="form-group mt-3 col-lg-3 pl-0 float-left p-res-0">
          <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.firstName' | cxTranslate" formControlName="firstName"/>
          <span class="highlight"></span>
          <label class="text-muted">{{ 'KnbrProfile.label.firstName' | cxTranslate }}</label>
        </div>
        <div class="form-group mt-3 col-lg-3 pl-0 float-left p-res-0">
          <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.lastName' | cxTranslate" formControlName="lastName"/>
          <span class="highlight"></span>
          <label class="text-muted">{{ 'KnbrProfile.label.lastName' | cxTranslate }}</label>
        </div>
        <div class="form-group mt-3 col-lg-3 pl-0 float-left p-res-0">
          <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.preferredName' | cxTranslate" formControlName="preferredName"/>
          <span class="highlight"></span>
          <label class="text-muted">{{ 'KnbrProfile.label.preferredName' | cxTranslate }}</label>
        </div>
        <div class="form-group mt-3 col-lg-3 pl-0 float-left p-res-0">
          <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.businessEmail' | cxTranslate" formControlName="businessEmail"/>
          <span class="highlight"></span>
          <label class="text-muted">{{ 'KnbrProfile.label.businessEmail' | cxTranslate }}</label>
        </div>
      </div>
      <div>
        <div class="form-group mt-3 col-lg-2 pl-0 float-left p-res-0">
          <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.businessPhone' | cxTranslate" formControlName="businessPhone"/>
          <span class="highlight"></span>
          <label class="text-muted">{{ 'KnbrProfile.label.businessPhone' | cxTranslate }}</label>
        </div>
        <div class="form-group mt-3 col-lg-1 pl-0 float-left p-res-0">
          <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.extension' | cxTranslate" formControlName="extension"/>
          <span class="highlight"></span>
          <label class="text-muted">{{ 'KnbrProfile.label.extension' | cxTranslate }}</label>
        </div>
        <div class="form-group mt-3 col-lg-3 pl-0 float-left p-res-0">
          <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.businessCell' | cxTranslate" formControlName="businessCell"/>
          <span class="highlight"></span>
          <label class="text-muted">{{ 'KnbrProfile.label.businessCell' | cxTranslate }}</label>
        </div>
        <div class="form-group mt-3 col-lg-3 pl-0 float-left p-res-0">
          <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.alternateMobileNumber' | cxTranslate" formControlName="alternateMobileNumber"/>
          <span class="highlight"></span>
          <label class="text-muted">{{ 'KnbrProfile.label.alternateMobileNumber' | cxTranslate }}</label>
        </div>
        <div class="form-group mt-3 col-lg-3 pl-0 float-left p-res-0">
          <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.hireDate' | cxTranslate" formControlName="hireDate"/>
          <span class="highlight"></span>
          <label class="text-muted">{{ 'KnbrProfile.label.hireDate' | cxTranslate }}</label>
          <i class="float-right far fa-calendar-alt color-font hireDate-icon" aria-hidden="true"></i>
        </div>
        <!-- <div class="form-group mt-3 col-lg-3 pl-0 float-left p-res-0">
        <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.terminationDate' | cxTranslate" formControlName="terminationDate"/>
        <span class="highlight"></span>
        <label class="text-muted">{{ 'KnbrProfile.label.terminationDate' | cxTranslate }}</label>
      </div> -->
    </div>
    <div class="col-lg-12 p-0 float-left mb-3 update-button-section">
      <div class="col-lg-2 p-0 m-0 mr-3 float-right">
        <button class="w-100 mt-1 mt-sm-0 btn btn-outline-primary" (click)="goTo()">
          {{ 'KnbrProfile.button.RequestProfileUpdate' | cxTranslate }}
        </button>
      </div>
      <span class="float-right col-lg-7 mt-3">Note: Click 'Request Profile Update' to make changes to your profile; you'll be redirected to 'Contact Us'</span>
    </div>
  </div>
  <!-- <div class="col-md-12 float-left customersearch-forms login-forms customer-home-forms mb-1">
  <span class="pl-0 font-text-400">Job Details</span>
  <div>
    <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
      <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.employeeId' | cxTranslate" formControlName="employeeId"/>
      <span class="highlight"></span>
      <label class="text-muted">{{ 'KnbrProfile.label.employeeId' | cxTranslate }}</label>
    </div>
    <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
      <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.employeeStatus' | cxTranslate" formControlName="employeeStatus"/>
      <span class="highlight"></span>
      <label class="text-muted">{{ 'KnbrProfile.label.employeeStatus' | cxTranslate }}</label>
    </div>
    <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
      <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.jobTitle' | cxTranslate" formControlName="jobTitle"/>
      <span class="highlight"></span>
      <label class="text-muted">{{ 'KnbrProfile.label.jobTitle' | cxTranslate }}</label>
    </div>
    <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
      <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.businessUser' | cxTranslate" formControlName="businessUser"/>
      <span class="highlight"></span>
      <label class="text-muted">{{ 'KnbrProfile.label.businessUser' | cxTranslate }}</label>
    </div>
  </div>
  <div>
    <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
      <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.role' | cxTranslate" formControlName="role"/>
      <span class="highlight"></span>
      <label class="text-muted">{{ 'KnbrProfile.label.role' | cxTranslate }}</label>
    </div>
    <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
      <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.subRole' | cxTranslate" formControlName="subRole"/>
      <span class="highlight"></span>
      <label class="text-muted">{{ 'KnbrProfile.label.subRole' | cxTranslate }}</label>
    </div>
    <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
      <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.internal' | cxTranslate" formControlName="internal"/>
      <span class="highlight"></span>
      <label class="text-muted">{{ 'KnbrProfile.label.internal' | cxTranslate }}</label>
    </div>
    <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
      <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.external' | cxTranslate" formControlName="external"/>
      <span class="highlight"></span>
      <label class="text-muted">{{ 'KnbrProfile.label.external' | cxTranslate }}</label>
    </div>
  </div>
  <div>
    <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
      <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.managerEmpId' | cxTranslate" formControlName="managerEmpId"/>
      <span class="highlight"></span>
      <label class="text-muted">{{ 'KnbrProfile.label.managerEmpId' | cxTranslate }}</label>
    </div>
    <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
      <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.managerFname' | cxTranslate" formControlName="managerFname"/>
      <span class="highlight"></span>
      <label class="text-muted">{{ 'KnbrProfile.label.managerFname' | cxTranslate }}</label>
    </div>
    <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
      <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.managerLname' | cxTranslate" formControlName="managerLname"/>
      <span class="highlight"></span>
      <label class="text-muted">{{ 'KnbrProfile.label.managerLname' | cxTranslate }}</label>
    </div>
    <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
      <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.managerPreferredName' | cxTranslate" formControlName="managerPreferredName"/>
      <span class="highlight"></span>
      <label class="text-muted">{{ 'KnbrProfile.label.managerPreferredName' | cxTranslate }}</label>
    </div>
  </div>
</div> -->
<!-- <div class="col-md-12 float-left customersearch-forms login-forms p-0 customer-home-forms mb-1">
<span class="pl-0 font-text-400">Organization Information</span>
<div class="row pl-3">
  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
    <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.departmentId' | cxTranslate" formControlName="departmentId"/>
    <span class="highlight"></span>
    <label class="text-muted">{{ 'KnbrProfile.label.departmentId' | cxTranslate }}</label>
  </div>
  <div class="form-group mt-3 col-lg-6 mr-auto pl-0 float-left mb-3 p-res-0">
    <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.departmentDescription' | cxTranslate" formControlName="departmentDescription"/>
    <span class="highlight"></span>
    <label class="text-muted">{{ 'KnbrProfile.label.departmentDescription' | cxTranslate }}</label>
  </div>
</div>
<div class="row pl-3">
  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
    <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.costCenterId' | cxTranslate" formControlName="costCenterId"/>
    <span class="highlight"></span>
    <label class="text-muted">{{ 'KnbrProfile.label.costCenterId' | cxTranslate }}</label>
  </div>
  <div class="form-group mt-3 col-lg-6 pl-0 float-left mb-3 p-res-0">
    <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.costCenterDescription' | cxTranslate" formControlName="costCenterDescription"/>
    <span class="highlight"></span>
    <label class="text-muted">{{ 'KnbrProfile.label.costCenterDescription' | cxTranslate }}</label>
  </div>
</div>
<div>
  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
    <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.divisionShortName' | cxTranslate" formControlName="divisionShortName"/>
    <span class="highlight"></span>
    <label class="text-muted">{{ 'KnbrProfile.label.divisionShortName' | cxTranslate }}</label>
  </div>
  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
    <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.divisionFullName' | cxTranslate" formControlName="divisionFullName"/>
    <span class="highlight"></span>
    <label class="text-muted">{{ 'KnbrProfile.label.divisionFullName' | cxTranslate }}</label>
  </div>
  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
    <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.businessUnit' | cxTranslate" formControlName="businessUnit"/>
    <span class="highlight"></span>
    <label class="text-muted">{{ 'KnbrProfile.label.businessUnit' | cxTranslate }}</label>
  </div>
  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
    <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.businessUnitName' | cxTranslate" formControlName="businessUnitName"/>
    <span class="highlight"></span>
    <label class="text-muted">{{ 'KnbrProfile.label.businessUnitName' | cxTranslate }}</label>
  </div>
</div>
<div>
  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
    <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.workLocation' | cxTranslate" formControlName="workLocation"/>
    <span class="highlight"></span>
    <label class="text-muted">{{ 'KnbrProfile.label.workLocation' | cxTranslate }}</label>
  </div>
  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
    <input type="text" class="form-control w-100" [placeholder]="'KnbrProfile.label.workLocationDesc' | cxTranslate" formControlName="workLocationDesc"/>
    <span class="highlight"></span>
    <label class="text-muted">{{ 'KnbrProfile.label.workLocationDesc' | cxTranslate }}</label>
  </div>
</div>
</div> -->
<!-- <div class="row">
<div class="col-md-5 float-left customersearch-forms login-forms pl-3 customer-home-forms mb-1">
  <h4 class="pl-0 font-text-400">Notification Details</h4>
  <div class="customersearch-list-table float-left pl-0">
    <div class="customersearch-list-titles border-top float-left w-100 p-2">
      <div class="col-md-9 float-left">
        Shipment Notification <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
      </div>
      <div class="col-md-2 float-left font-text-400 font-md-size pl-0">
        Email
      </div>
    </div>
    <div class="bg-white table-content border-top float-left w-100 p-1" *ngFor="let notification of this.notificationListData; let i = index">
      <div class="col-md-9 float-left">
        <span class="">{{ notification.notificationType }}</span>
      </div>
      <div class="col-md-2 form-check-inline">
        <input type="checkbox" class="form-check-input" (change)="select(notification.notificationMode, $event.target.checked)" [checked]=""/>
      </div>
    </div>
  </div>
</div>
</div> -->
</form>
}
<!-- <div class="row justify-content-end my-3">
<div class="col-md-2 pl-0 p-res-0 float-left">
  <button type="submit" class="w-100 btn btn-primary">
    {{ 'button.cancel' | cxTranslate }}
  </button>
</div>

<div class="col-md-2 pl-0 p-res-0 float-left">
  <button type="button" class="w-100 btn btn-outline-primary">
    {{ 'button.save' | cxTranslate }}
  </button>
</div>
</div> -->
</ng-container>
